class ExpertVideo {
  constructor(data) {
    this.modal = document.getElementById('expert-video-modal')
    this.contentContainerEl = this.modal.querySelector('.content')
    this.loadingSpinnerEl = this.modal.querySelector('.loading')
    this.videoEl = this.modal.querySelector('.video')
    this.headingEl = this.modal.querySelector('.heading')
    this.descriptionEl = this.modal.querySelector('.description')
    this.nextVideoEl = this.modal.querySelector('.next-video')
    this.iframe = document.createElement('IFRAME')
    this.iframe.setAttribute('allow', 'autoplay; fullscreen')
    this.videoEl.appendChild(this.iframe)
    this.data = data
    this.uuid = ''
    this.currentKey = 0
  }
  init() {
    this.nextVideoEl.addEventListener('click', () => {
      this.setVideo(this.nextVideoEl.getAttribute('data-uuid'))
    })
  }
  setVideo(uuid) {
    this.uuid = uuid
    this.currentKey = this.findCurrentKey()
    this.nextVideoUuid = this.getNextVideoUuid()

    // console.log('this.currentKey', this.currentKey)
    // console.log('this.nextVideoUuid', this.nextVideoUuid)

    this.render()
  }

  render() {

    this.loadingSpinnerEl.classList.add('hide')
    this.contentContainerEl.classList.add('active')
    this.headingEl.innerHTML = '<h3>' + this.data[this.currentKey].field_heading + '</h3>'
    this.iframe.setAttribute('src', this.data[this.currentKey]['field_iframe_source'] + ((!iOS()) ? '?autoplay=1' : '?loop=1'))
    this.descriptionEl.innerHTML = this.data[this.currentKey].body
    this.nextVideoEl.innerHTML = this.data[this.currentKey].field_next_video_label
    this.nextVideoEl.setAttribute('data-uuid', this.nextVideoUuid)
    // this.videoEl.innerHTML = '<iframe src="' + this.data[this.currentKey]['field_iframe_source'] +'" allow="autoplay; fullscreen" allowfullscreen></iframe>'
  }

  findCurrentKey() {
    for (let i = 0; i < this.data.length; i++) {
      if (this.uuid === this.data[i].uuid) {
        return i
      }
    }
    console.error('Cannot find uuid')
  }

  getNextVideoUuid() {
    if (this.currentKey === this.data.length - 1) {
      return this.data[0].uuid
    }
    return this.data[this.currentKey + 1].uuid
  }
  stop() {
    this.iframe.src = ''
    // console.log(this.iframe)
    // console.log('stopping')
  }

}

function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
}
export default ExpertVideo


// WEBPACK FOOTER //
// ./js/classes/expert-video.js